import { Component, OnInit } from '@angular/core';

type SifrarnikLayer =
  | 'codebook'
  | 'employees'
  | 'konto'
  | 'schema'
  | 'organizationalUnits'
  | 'priceList';

@Component({
  selector: 'app-sifrarnik',
  templateUrl: './sifrarnik.component.html',
  styleUrls: ['./sifrarnik.component.css']
})
export class SifrarnikComponent implements OnInit {
  activeLayer: SifrarnikLayer = 'codebook';

  constructor() { }

  ngOnInit(): void {
  }

  setActiveLayer(layer: SifrarnikLayer): void {
    this.activeLayer = layer;
  }
}
